import {Base} from "@/api/Base"

export class AnnualLeavePlanDelete extends Base {
    path = "annualLeavePlan/delete"
}